import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import initialDetails from '../../components/servizi/data/output';
import Jumbotron from 'react-bootstrap/Jumbotron';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Container from 'react-bootstrap/Container';

import Servizi from '../../components/servizi/components/Search_pagDettagli';
import SocialShare from '../../components/servizi/SocialShare';
import HorizontalNav from '../../components/servizi/HorizontalNav';
import BottoniRichiediInfoPrevDoc from '../../components/servizi/BottoniRichiediInfoPrevDoc';
import { useMediaQuery } from 'react-responsive';
import Footer from '../../components/Footer';

import TagComponent from '../../components/tags/index';

import './styles.css';


const ServizioApprofondisci_contenuto = ({ servizio }) => {

    
    const isDesktopOrLaptop = useMediaQuery({
        query: '(min-width: 1224px)'
    })

    const location_origin = typeof window !== "undefined" ? `${window.location.href.toString()}` : `https://www.notaio-treviso.com/servizi/${servizio.link}`

    return (
        <section id='divAppCont'
            className="paralax-mf footer-paralax bg-image route secBack"
        >
            <Container style={{ marginTop: "65px" }} fluid="md">

                <Row className="justify-content-md-center">
                    <h1 className='titleTop'>
                        {servizio.name}
                    </h1>
                </Row>

                {isDesktopOrLaptop ?
                    <Row>
                        <Col className='col-md-8'>
                            <Row>
                                <HorizontalNav
                                    link1={'/servizi'}
                                    name1={'Servizi'}
                                    symbol1={'>'}
                                    link2={''}
                                    name2={''}
                                    symbol2={''}
                                    pageName={servizio.name} />
                            </Row>
                            <Row>
                                <SocialShare urlSpec={location_origin} />
                                <Container className='articoloBoxDesktop'>
                                    <div className="content post_content" dangerouslySetInnerHTML={{ __html: servizio.corpus }}></div>
                                </Container>
                            </Row>
                        </Col>

                        <Col className='col-md-4'>
                            <Row className="justify-content-md-center">
                                <BottoniRichiediInfoPrevDoc servizio={servizio.link} />
                            </Row>

                            <div className='tagbox'>
                                <div className='titleTag'>TAG</div>
                                <div className='corpusTag'>
                                    {servizio.tag.map(tag => {
                                        return (
                                            <div className='tag'>#{tag}</div>
                                        );
                                    })}
                                </div>
                            </div>
                            <Row>
                                <Servizi details={initialDetails} tipologia={servizio.tipologia} />
                            </Row>
                        </Col>
                    </Row>
                    :
                    <Container>
                        <Row>
                            <HorizontalNav
                                link1={'/servizi'}
                                name1={'Servizi'}
                                symbol1={'>'}
                                link2={''}
                                name2={''}
                                symbol2={''}
                                pageName={servizio.name}
                            />
                        </Row>
                        <Row >
                            <SocialShare urlSpec={location_origin + "/servizi/" + servizio.link} />
                            <Container className='articoloBoxMobile'>
                                <div className="content post_content" dangerouslySetInnerHTML={{ __html: servizio.corpus }}></div>
                            </Container>
                            <BottoniRichiediInfoPrevDoc servizio={servizio.link} />
                            <div className='tagbox'>
                                <div className='titleTag'>TAG</div>
                                <div className='corpusTag'>
                                    {servizio.tag.map(tag => {
                                        return (
                                            <div className='tag'>#{tag}</div>
                                        );
                                    })}
                                </div>
                            </div>
                        </Row>
                        <Row className="justify-content-md-center">
                            <Servizi details={initialDetails} tipologia={servizio.tipologia} />
                        </Row>
                    </Container>
                }

                <Row>
                </Row>
            </Container>
            
            <TagComponent />
            <Footer />
        </section>
    );
}

export default ServizioApprofondisci_contenuto;
